import React from "react";
import { Typography } from "@material-ui/core";
import { InlineType } from "../../../components/InlineType";

export type ServiceListProps = {
  list: any[];
  singular: string;
  plural: string;
};
export const ServiceList: React.FC<ServiceListProps> = ({
  list,
  singular,
  plural,
}) => {
  const count = list?.length ?? 0;
  const prefix = count === 1 ? singular : `${count} ${plural}`;

  return count ? (
    <Typography variant="body1">
      <InlineType fontWeight="bold">
        {`${prefix}: ${list.join(", ")}`}
      </InlineType>
    </Typography>
  ) : null;
};
